module.exports = __webpack_public_path__ + "static/media/appliance-gas.73fac1d1.png";